import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Avive AED';

const AVIVE_EVENT_NAMES = {
  SEARCHED: 'tools_avive_aed_launched',
  CURRENT_LOCATION_CLICKED: 'tools_avive_current_location_clicked',
  NOTE_UPDATED: 'tools_avive_note_updated',
  CANCELED: 'tools_avive_aed_canceled',
  SEARCH_BY_LOCATION: 'tools_avive_aed_launched_by_location',
  TIMEOUT: 'tools_avive_aed_timeout',
};

/**
 * Tracks successful AED search requests.
 */
export const trackSearched = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.SEARCHED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'AED launched',
      Category: LEGACY_CATEGORY,
    },
  });
};

/**
 * Tracks clicks on the "Current Location" button in AviveSearchForm.
 */
export const trackCurrentLocationClicked = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.CURRENT_LOCATION_CLICKED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'Current Location clicked',
      Category: LEGACY_CATEGORY,
    },
  });
};

/**
 * Tracks when a note has been updated.
 */
export const trackNoteUpdated = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.NOTE_UPDATED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'Note updated',
      Category: LEGACY_CATEGORY,
    },
  });
};

/**
 * Tracks successful AED search cancellations.
 */
export const trackCanceled = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.CANCELED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'AED canceled',
      Category: LEGACY_CATEGORY,
    },
  });
};

/**
 * Tracks successful searches using location coordinates.
 */
export const trackOptionSearchByLocation = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.SEARCH_BY_LOCATION,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'AED launched by location',
      Category: LEGACY_CATEGORY,
    },
  });
};

/**
 * Tracks searches that timeout.
 */
export const trackTimeout = () => {
  gspx.trackEvent({
    name: AVIVE_EVENT_NAMES.TIMEOUT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.TOOLS,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: 'AED timeout',
      Category: LEGACY_CATEGORY,
    },
  });
};
